import { createPopper } from "@popperjs/core/dist/esm";

const initDots = () => {
	const dots = document.querySelectorAll(".dot");
	const footmat = document.querySelector("#footmat-interior-screen");
	for (var dot of dots) {
		var anchor = dot.querySelector(".anchor");
		var popup = dot.querySelector(".popup");
		if (footmat) {
			createPopper(anchor, popup, {
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [-80, 18],
						},
					},
				],
			});
		} else {
			createPopper(anchor, popup, {
				modifiers: [
					{
						name: "offset",
						options: {
							offset: [80, 18],
						},
					},
				],
			});
		}
		document.querySelector('.display').addEventListener("click", (e) =>{
			let activeDot = document.querySelector(".is-active");
			activeDot?.classList.remove("is-active");
		})
		dot?.addEventListener("click", (e) => {
			let activeDot = document.querySelector(".is-active");
			if (activeDot) activeDot.classList.remove("is-active");
			e.target.classList.add("is-active");
			e.stopPropagation();
		});
		popup?.addEventListener("click", (e) => {
			e.stopPropagation();
		});
		anchor?.addEventListener("click", (e) => {
			e.stopPropagation();
		});
	}
};

export { initDots };
